// extracted by mini-css-extract-plugin
module.exports = {"top":"footer_top__mG36T","user":"footer_user__5UC4d","content":"footer_content__LnT79","nameGroup":"footer_nameGroup__149Yd","icons":"footer_icons__kOG7i"};